import { render, staticRenderFns } from "./addnewfile.vue?vue&type=template&id=55039adf&scoped=true&"
import script from "./addnewfile.vue?vue&type=script&lang=js&"
export * from "./addnewfile.vue?vue&type=script&lang=js&"
import style0 from "./addnewfile.vue?vue&type=style&index=0&id=55039adf&lang=less&scoped=true&"
import style1 from "./addnewfile.vue?vue&type=style&index=1&id=55039adf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55039adf",
  null
  
)

export default component.exports